/** `ez.t.item_name_changed` — *When an item name changes* (recipe 1004, 4 webhook automations). */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const itemNameChangedParams = z.object({});
export const itemNameChangedTrigger = defineTrigger({
    id: 'ez.t.item_name_changed',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an item name changes',
    paramsSchema: itemNameChangedParams,
    subscribes: ['item.updated'],
    assumed: true,
    references: () => [],
    matches: (event) => Array.isArray(event.payload.changed) && event.payload.changed.includes('name'),
    outputs: (event) => ({ itemId: event.itemId, boardId: event.boardId, name: event.payload.name, previousName: event.payload.previousName }),
});
//# sourceMappingURL=ez.t.item-name-changed.js.map